import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { HeaderTypeTokens, StepperTypeTokens, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { continueAction, goBack, needHelp, proceedToNextStep, uploadDocumentsAction } from "./actions";
import { horizontalStepperRepo } from "../../configs/utils";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../SharedPropsService";
export const template = (height, stepper, documentsListing, isFromJupiter) => ({
    layout: {
        id: ROUTE.AS_ES_DOCUMENTS_LISTING,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: "asESDocumentsListingDC", type: WIDGET.AS_ES_DOCUMENTS_LISTING
            }
        ],
    },
    datastore: {
        asESDocumentsListingDC: {
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.AS_ES_DOCUMENTS_LISTING,
                payload: {}
            },
            type: HeaderTypeTokens.verification,
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.AS_ES_DOCUMENTS_LISTING,
                payload: {}
            },
            stepperData: {
                data: stepper,
                type: StepperTypeTokens.HORIZONTAL,
            },
            uploadDocumentsAction: {
                type: ACTION.UPLOAD_DOCUMENTS_ACTON,
                routeId: ROUTE.AS_ES_DOCUMENTS_LISTING,
                payload: {}
            },
            documentsListing: documentsListing,
            submitAction: {
                type: ACTION.PROCEED_TO_NEXT_STEP,
                routeId: ROUTE.AS_ES_DOCUMENTS_LISTING,
                payload: {}
            },
            continueAction: {
                type: ACTION.CONTINUE_ACTION,
                routeId: ROUTE.AS_ES_DOCUMENTS_LISTING,
                payload: {}
            },
            isFromJupiter: isFromJupiter
        }
    },
});
export const asESDocumentsListingMF = {
    onLoad: async ({ getHeight, network }) => {
        const stepper = await horizontalStepperRepo(network);
        let applicationId;
        if (await AsyncStorage.getItem("application_id")) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            const user = await SharedPropsService.getUser();
            applicationId = user.linkedApplications[0].applicationId;
        }
        const getDocumentsList = await network.post(`${api.getDocumentsList}`, {
            applicationId: applicationId
        }, {
            headers: await getAppHeader(),
        });
        const documentsListing = getDocumentsList?.data?.stepResponseObject;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        return Promise.resolve(template(getHeight(), stepper, documentsListing, isFromJupiter));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.UPLOAD_DOCUMENTS_ACTON]: uploadDocumentsAction,
        [ACTION.PROCEED_TO_NEXT_STEP]: proceedToNextStep,
        [ACTION.CONTINUE_ACTION]: continueAction,
    },
    clearPrevious: true,
};
